import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './user_layout.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css'
import './style.css';
import { createStore, applyMiddleware } from 'redux'
import { Provider } from 'react-redux'
import rootReducer from './reducers/rootReducer'
import thunk from 'redux-thunk'

import './styles/main.css'

const store = createStore(rootReducer, applyMiddleware(thunk));

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename='/app/'>
      <App />
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);
